import React from "react";
// import { Outlet } from "react-router-dom";

// page
import StockPage from "../pages/stock";
import FbpagePage from "../pages/fbpage";
import FbpagepostPage from "../pages/fbpagepost";

// eslint-disable-next-line
export default {
  path: "/fbpagepost/:fbId",
  element: <FbpagepostPage />,
  errorElement: <p>error</p>,
  // children: [
  //   {
  //     path: "settingTable/:id",
  //     element: <SettingTable />,
  //   },
  // ],
};
